module.exports = __webpack_public_path__ + "media/images/wishlistWhite-9ffdaf5ec6acd11c5eaedd043270d4aa.svg";